import LdCustomSwiperTabs from "./ld-custom-swiper-tabs.js";

if (!customElements.get("ld-series-grid")) {
  customElements.define(
    "ld-series-grid",
    class LdSeriesGrid extends HTMLElement {
      constructor() {
        super();
        this.isMobile = window.innerWidth <= 768;
      }

      initSwiperDesktop() {
        if (!this.isMobile) {
          return;
        }
        const wrapper = this.querySelector(".swiper");
        const slidesSize = wrapper.querySelectorAll(".swiper-slide").length;
        if (slidesSize <= 1) {
          return;
        }
        const swiper = new Swiper(wrapper, {
          slidesPerView: 1.1,
          threshold: 30,
          spaceBetween: 0,
          centeredSlides: true,
          // simulateTouch: this.isMobile,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: wrapper.querySelector(".swiper-pagination"),
            clickable: true,
          },
        });
        const tabsControl = new LdCustomSwiperTabs({
          element: this.querySelector(".custom-swiper-tabs"),
        });
        swiper.on("slideChange", () => {
          tabsControl.select(swiper.realIndex);
        });
        tabsControl.onIndexChange((index) => {
          swiper.slideToLoop(index);
        });
      }

      connectedCallback() {
        this.initSwiperDesktop();
      }
    }
  );
}
